import React, { useState, useEffect } from "react";
import "./FurnitureCategories.css";

import diningTableImage from "../images/dining-table.jpg";
import cabinetImage from "../images/cabinet.jpeg";
import sideboardImage from "../images/sideboard.jpg";
import wardrobeImage from "../images/wardrobes (3).jpeg";
import bedImage from "../images/bed.jpg";
import nestingTableImage from "../images/nesting-table.jpeg";
import wallDividerImage from "../images/wall-deviders.jpg";
import cofeetable from "../images/cofeetable.jpeg";
import endtable from "../images/endtable.jpeg";
import sculpture from "../images/sculpture.jpeg";
import sculpture1 from "../Intradingphoto/13. SCULPTURES/13 1-100kb.jpeg";
import sculpture2 from "../Intradingphoto/13. SCULPTURES/13 2-100kb.jpeg";
import sculpture3 from "../Intradingphoto/13. SCULPTURES/13 3-100kb.jpeg";
import sculpture4 from "../Intradingphoto/13. SCULPTURES/13 4-100kb.jpeg";
import sculpture5 from "../Intradingphoto/13. SCULPTURES/13 5-100kb.jpeg";
import sculpture6 from "../Intradingphoto/13. SCULPTURES/13 6-100kb.jpeg";
import sculpture7 from "../Intradingphoto/13. SCULPTURES/13 7-100kb.jpeg";
import sculpture8 from "../Intradingphoto/13. SCULPTURES/13 8-100kb.jpeg";
import sculpture9 from "../Intradingphoto/13. SCULPTURES/13 9-100kb.jpeg";
import sculpture10 from "../Intradingphoto/13. SCULPTURES/13 10-100kb.jpeg";
import sculpture11 from "../Intradingphoto/13. SCULPTURES/13 11-100kb.jpeg";
import sculpture12 from "../Intradingphoto/13. SCULPTURES/13 12-100kb.jpeg";


import desk from "../images/desk.jpeg";
import bar from "../images/bar.jpeg";
import barchair from "../images/barchair.jpeg";
import tv from "../images/tv.jpeg";

import barchair1 from "../images/barchair100.jpeg";

import diningtable101 from "../images/dinning-table101.jpeg";
import dinningtable102 from "../images/dinning-table102.jpeg";
import diningtable103 from "../Intradingphoto/1. Dining/1 1-100kb.jpeg";
import diningtable104 from "../Intradingphoto/1. Dining/1 2-100kb.jpeg";
import diningtable105 from "../Intradingphoto/1. Dining/1 3-100kb.jpeg";
import diningtable106 from "../Intradingphoto/1. Dining/1 4-100kb.jpeg";
import diningtable107 from "../Intradingphoto/1. Dining/1 5-100kb.jpeg";
import diningtable108 from "../Intradingphoto/1. Dining/1 6-100kb.jpeg";
import diningtable109 from "../Intradingphoto/1. Dining/1 7-100kb.jpeg";
import diningtable110 from "../Intradingphoto/1. Dining/1 8-100kb.jpeg";
import diningtable111 from "../Intradingphoto/1. Dining/1 9-100kb.jpeg";
import diningtable112 from "../Intradingphoto//1. Dining/1 10-100kb.jpeg";
import diningtable113 from "../Intradingphoto//1. Dining/1 11-100kb.jpeg";
import diningtable114 from "../Intradingphoto//1. Dining/1 12-100kb.jpeg";

import endtable103 from "../images/end-table103.jpeg";
import endtable104 from "../images/endtable104.jpeg";
import endtable105 from "../Intradingphoto/9. END TABLES/9 1-100kb.jpeg";
import endtable106 from "../Intradingphoto/9. END TABLES/9 2-100kb.jpeg";
import endtable107 from "../Intradingphoto/9. END TABLES/9 3-100kb.jpeg";
import endtable108 from "../Intradingphoto/9. END TABLES/9 4-100kb.jpeg";
import endtable109 from "../Intradingphoto/9. END TABLES/9 5-100kb.jpeg";
import endtable110 from "../Intradingphoto/9. END TABLES/9 6-100kb.jpeg";
import endtable111 from "../Intradingphoto/9. END TABLES/9 7-100kb.jpeg";
import endtable112 from "../Intradingphoto/9. END TABLES/9 8-100kb.jpeg";
import endtable113 from "../Intradingphoto/9. END TABLES/9 9-100kb.jpeg";
import endtable114 from "../Intradingphoto/9. END TABLES/9 10-100kb.jpeg";
import endtable115 from "../Intradingphoto/9. END TABLES/9 11-100kb.jpeg";
import endtable116 from "../Intradingphoto/9. END TABLES/9 12-100kb.jpeg";


import cofeetable105 from "../images/coffee-table105.jpeg";
import cofeetable106 from "../images/coffee-table106.jpeg";
import cofeetable107 from "../Intradingphoto/8. Coffee Table/8 1-100kb.jpeg";
import cofeetable108 from "../Intradingphoto/8. Coffee Table/8 2-100kb.jpeg";
import cofeetable109 from "../Intradingphoto/8. Coffee Table/8 3-100kb.jpeg";
import cofeetable110 from "../Intradingphoto/8. Coffee Table/8 4-100kb.jpeg";
import cofeetable111 from "../Intradingphoto/8. Coffee Table/8 5-100kb.jpeg";
import cofeetable112 from "../Intradingphoto/8. Coffee Table/8 6-100kb.jpeg";
import cofeetable113 from "../Intradingphoto/8. Coffee Table/8 7-100kb.jpeg";
import cofeetable114 from "../Intradingphoto/8. Coffee Table/8 8-100kb.jpeg";
import cofeetable115 from "../Intradingphoto/8. Coffee Table/8 9-100kb.jpeg";
import cofeetable116 from "../Intradingphoto/8. Coffee Table/8 10-100kb.jpeg";
import cofeetable117 from "../Intradingphoto/8. Coffee Table/8 11-100kb.jpeg";
import cofeetable118 from "../Intradingphoto/8. Coffee Table/8 12-100kb.jpeg";


import walldivider107 from "../images/wall-divider107.jpeg";
import walldivider108 from "../images/wall-divider108.jpeg";
import walldivider109 from "../Intradingphoto/7. WALL DIVIDERS/7 1-100kb.jpeg";
import walldivider110 from "../Intradingphoto/7. WALL DIVIDERS/7 2-100kb.jpeg";
import walldivider111 from "../Intradingphoto/7. WALL DIVIDERS/7 3-100kb.jpeg";
import walldivider112 from "../Intradingphoto/7. WALL DIVIDERS/7 4-100kb.jpeg";
import walldivider113 from "../Intradingphoto/7. WALL DIVIDERS/7 5-100kb.jpeg";
import walldivider114 from "../Intradingphoto/7. WALL DIVIDERS/7 6-100kb.jpeg";
import walldivider115 from "../Intradingphoto/7. WALL DIVIDERS/7 7-100kb.jpeg";
import walldivider116 from "../Intradingphoto/7. WALL DIVIDERS/7 8-100kb.jpeg";
import walldivider117 from "../Intradingphoto/7. WALL DIVIDERS/7 9-100kb.jpeg";
import walldivider118 from "../Intradingphoto/7. WALL DIVIDERS/7 10-100kb.jpeg";
import walldivider119 from "../Intradingphoto/7. WALL DIVIDERS/7 11-100kb.jpeg";


import nestingtable109 from "../images/nesting-table109.jpeg";
import nestingtable110 from "../images/nesting-table110.jpeg";
import nestingtable111 from "../Intradingphoto/5. NESTING TABLES/5 1-100kb.jpeg";
import nestingtable112 from "../Intradingphoto/5. NESTING TABLES/5 2-100kb.jpeg";
import nestingtable113 from "../Intradingphoto/5. NESTING TABLES/5 3-100kb.jpeg";
import nestingtable114 from "../Intradingphoto/5. NESTING TABLES/5 4-100kb.jpeg";
import nestingtable115 from "../Intradingphoto/5. NESTING TABLES/5 5-100kb.jpeg";
import nestingtable116 from "../Intradingphoto/5. NESTING TABLES/5 6-100kb.jpeg";
import nestingtable117 from "../Intradingphoto/5. NESTING TABLES/5 7-100kb.jpeg";
import nestingtable118 from "../Intradingphoto/5. NESTING TABLES/5 8-100kb.jpeg";
import nestingtable119 from "../Intradingphoto/5. NESTING TABLES/5 9-100kb.jpeg";
import nestingtable120 from "../Intradingphoto/5. NESTING TABLES/5 10-100kb.jpeg";
import nestingtable121 from "../Intradingphoto/5. NESTING TABLES/5 11-100kb.jpeg";
import nestingtable122 from "../Intradingphoto/5. NESTING TABLES/5 12-100kb.jpeg";

import bed111 from "../images/bed111.jpeg";
import bed112 from "../images/bed112.jpeg";
import bed113 from "../Intradingphoto/6. Beds/6 1-100kb.jpeg";
import bed114 from "../Intradingphoto/6. Beds/6 2-100kb.jpeg";
import bed115 from "../Intradingphoto/6. Beds/6 3-100kb.jpeg";
import bed116 from "../Intradingphoto/6. Beds/6 4-100kb.jpeg";
import bed117 from "../Intradingphoto/6. Beds/6 5-100kb.jpeg";
import bed118 from "../Intradingphoto/6. Beds/6 6-100kb.jpeg";

import wardrobe113 from "../images/wardrobe113.jpeg";
import wardrobe114 from "../Intradingphoto/3. Wardrobes/3 1-100kb.jpeg";
import wardrobe115 from "../Intradingphoto/3. Wardrobes/3 2-100kb.jpeg";
import wardrobe116 from "../Intradingphoto/3. Wardrobes/3 3-100kb.jpeg";
import wardrobe117 from "../Intradingphoto/3. Wardrobes/3 4-100kb.jpeg";
import wardrobe118 from "../Intradingphoto/3. Wardrobes/3 5-100kb.jpeg";
import wardrobe119 from "../Intradingphoto/3. Wardrobes/3 6-100kb.jpeg";
import wardrobe120 from "../Intradingphoto/3. Wardrobes/3 7-100kb.jpeg";
import wardrobe121 from "../Intradingphoto/3. Wardrobes/3 8-100kb.jpeg";
import wardrobe122 from "../Intradingphoto/3. Wardrobes/3 9-100kb.jpeg";
import wardrobe123 from "../Intradingphoto/3. Wardrobes/3 10-100kb.jpeg";

import wardrobe124 from "../images/wardrobe114.jpeg";

import tvunit115 from "../images/tv-unit115.jpeg";
import tvunit116 from "../images/tv-unit116.jpeg";
import tvunit117 from "../Intradingphoto/12. TV UNITS/12 1-100kb.jpeg";
import tvunit118 from "../Intradingphoto/12. TV UNITS/12 2-100kb.jpeg";
import tvunit119 from "../Intradingphoto/12. TV UNITS/12 3-100kb.jpeg";
import tvunit120 from "../Intradingphoto/12. TV UNITS/12 4-100kb.jpeg";
import tvunit121 from "../Intradingphoto/12. TV UNITS/12 5-100kb.jpeg";
import tvunit122 from "../Intradingphoto/12. TV UNITS/12 6-100kb.jpeg";
import tvunit123 from "../Intradingphoto/12. TV UNITS/12 7-100kb.jpeg";
import tvunit124 from "../Intradingphoto/12. TV UNITS/12 8-100kb.jpeg";
import tvunit125 from "../Intradingphoto/12. TV UNITS/12 9-100kb.jpeg";
import tvunit126 from "../Intradingphoto/12. TV UNITS/12 10-100kb.jpeg";
import tvunit127 from "../Intradingphoto/12. TV UNITS/12 11-100kb.jpeg";
import tvunit128 from "../Intradingphoto/12. TV UNITS/12 12-100kb.jpeg";

import cabinet117 from "../images/cabinet117.jpeg";
import cabinet118 from "../images/cabinet118.jpeg";
import cabinet119 from "../Intradingphoto/2. Cabinate/2 1-100kb.jpeg";
import cabinet120 from "../Intradingphoto/2. Cabinate/2 2-100kb.jpeg";
import cabinet121 from "../Intradingphoto/2. Cabinate/2 3-100kb.jpeg";
import cabinet122 from "../Intradingphoto/2. Cabinate/2 4-100kb.jpeg";
import cabinet123 from "../Intradingphoto/2. Cabinate/2 5-100kb.jpeg";
import cabinet124 from "../Intradingphoto/2. Cabinate/2 6-100kb.jpeg";
import cabinet125 from "../Intradingphoto/2. Cabinate/2 7-100kb.jpeg";
import cabinet126 from "../Intradingphoto/2. Cabinate/2 8-100kb.jpeg";
import cabinet127 from "../Intradingphoto/2. Cabinate/2 9-100kb.jpeg";
import cabinet128 from "../Intradingphoto/2. Cabinate/2 10-100kb.jpeg";
import cabinet129 from "../Intradingphoto/2. Cabinate/2 11-100kb.jpeg";
import cabinet130 from "../Intradingphoto/2. Cabinate/2 12-100kb.jpeg";

import desk119 from "../images/desk119.jpeg";
import desk120 from "../images/desk120.jpeg";
import desk121 from "../Intradingphoto/10. Desk-Console/10 1-100kb.jpeg";
import desk122 from "../Intradingphoto/10. Desk-Console/10 2-100kb.jpeg";
import desk123 from "../Intradingphoto/10. Desk-Console/10 3-100kb.jpeg";
import desk124 from "../Intradingphoto/10. Desk-Console/10 4-100kb.jpeg";
import desk125 from "../Intradingphoto/10. Desk-Console/10 5-100kb.jpeg";
import desk126 from "../Intradingphoto/10. Desk-Console/10 6-100kb.jpeg";
import desk127 from "../Intradingphoto/10. Desk-Console/10 7-100kb.jpeg";
import desk128 from "../Intradingphoto/10. Desk-Console/10 8-100kb.jpeg";
import desk129 from "../Intradingphoto/10. Desk-Console/10 9-100kb.jpeg";
import desk130 from "../Intradingphoto/10. Desk-Console/10 10-100kb.jpeg";
import desk131 from "../Intradingphoto/10. Desk-Console/10 11-100kb.jpeg";
import desk132 from "../Intradingphoto/10. Desk-Console/10 12-100kb.jpeg";

import sideboard121 from "../images/sideboard121.jpeg";
import sideboard122 from "../images/sideboard122.jpeg";
import sideboard123 from "../Intradingphoto/4. Side Boards/4 1-100kb.jpeg";
import sideboard124 from "../Intradingphoto/4. Side Boards/4 2-100kb.jpeg";
import sideboard125 from "../Intradingphoto/4. Side Boards/4 3-100kb.jpeg";
import sideboard126 from "../Intradingphoto/4. Side Boards/4 4-100kb.jpeg";
import sideboard127 from "../Intradingphoto/4. Side Boards/4 5-100kb.jpeg";
import sideboard128 from "../Intradingphoto/4. Side Boards/4 6-100kb.jpeg";
import sideboard129 from "../Intradingphoto/4. Side Boards/4 7-100kb.jpeg";
import sideboard130 from "../Intradingphoto/4. Side Boards/4 8-100kb.jpeg";
import sideboard131 from "../Intradingphoto/4. Side Boards/4 9-100kb.jpeg";
import sideboard132 from "../Intradingphoto/4. Side Boards/4 10-100kb.jpeg";
import sideboard133 from "../Intradingphoto/4. Side Boards/4 11-100kb.jpeg";
import sideboard134 from "../Intradingphoto/4. Side Boards/4 12-100kb.jpeg";

import bar123 from "../images/bar123.jpeg";
import bar124 from "../images/bar124.jpeg";
import bar125 from "../Intradingphoto/11. bar/11 1-100kb.jpeg";
import bar126 from "../Intradingphoto/11. bar/11 2-100kb.jpeg";
import bar127 from "../Intradingphoto/11. bar/11 3-100kb.jpeg";
import bar128 from "../Intradingphoto/11. bar/11 4-100kb.jpeg";
import bar129 from "../Intradingphoto/11. bar/11 5-100kb.jpeg";
import bar130 from "../Intradingphoto/11. bar/11 6-100kb.jpeg";
import bar131 from "../Intradingphoto/11. bar/11 7-100kb.jpeg";
import bar132 from "../Intradingphoto/11. bar/11 8-100kb.jpeg";
import bar133 from "../Intradingphoto/11. bar/11 9-100kb.jpeg";
import bar134 from "../Intradingphoto/11. bar/11 10-100kb.jpeg";


import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";


// =====================================================
// CATEGORIES
// =====================================================

const categories = [
  {
    title: "Dining Tables",
    subtitle: "Elegant handcrafted dining collections",
    images: [
      diningTableImage,
      diningtable101,
      dinningtable102,
      diningtable103,
      diningtable104,
      diningtable105,
      diningtable106,
      diningtable107,
      diningtable108,
      diningtable109,
      diningtable110,
      diningtable111,
      diningtable112,
      diningtable113,
      diningtable114,
    ],
  },

  {
    title: "Cabinets",
    subtitle: "Premium storage solutions",
    images: [
      cabinetImage,
      cabinet117,
      cabinet118,
      cabinet119,
      cabinet120,
      cabinet121,
      cabinet122,
      cabinet123,
      cabinet124,
      cabinet125,
      cabinet126,
      cabinet127,
      cabinet128,
      cabinet129,
      cabinet130,
    ],
  },

  {
    title: "Sideboards",
    subtitle: "Modern sideboard designs",
    images: [
      sideboardImage,
      sideboard121,
      sideboard122,
      sideboard123,
      sideboard124,
      sideboard125,
      sideboard126,
      sideboard127,
      sideboard128,
      sideboard129,
      sideboard130,
      sideboard131,
      sideboard132,
      sideboard133,
      sideboard134,
    ],
  },

  {
    title: "Wardrobes",
    subtitle: "Stylish wardrobes",
    images: [
      wardrobeImage,
      wardrobe113,
      wardrobe114,
      wardrobe115,
      wardrobe116,
      wardrobe117,
      wardrobe118,
      wardrobe119,
      wardrobe120,
      wardrobe121,
      wardrobe122,
      wardrobe123,
      wardrobe124,
   
    ],
  },

  {
    title: "Beds",
    subtitle: "Comfort meets luxury",
    images: [
      bedImage,
      bed111,
      bed112,
      bed113,
      bed114,
      bed115,
      bed116,
      bed117,
      bed118,
   
    ],
  },

  {
    title: "Nesting Tables",
    subtitle: "Space-saving elegance",
    images: [
      nestingTableImage,
      nestingtable109,
      nestingtable110,
      nestingtable111,
      nestingtable112,
      nestingtable113,
      nestingtable114,
      nestingtable115,
      nestingtable116,
      nestingtable117,
      nestingtable118,
      nestingtable119,
      nestingtable120,
      nestingtable121,
      nestingtable122,
    
    ],
  },

  {
    title: "Wall Dividers",
    subtitle: "Decorative room separators",
    images: [
      wallDividerImage,
      walldivider107,
      walldivider108,
      walldivider109,
      walldivider110,
      walldivider111,
      walldivider112,
      walldivider113,
      walldivider114,
      walldivider115,
      walldivider116,
      walldivider117,
      walldivider118,
      walldivider119,

    ],
  },

  {
    title: "Coffee Tables",
    subtitle: "Elegant coffee table designs",
    images: [
      cofeetable,
      cofeetable105,
      cofeetable106,
      cofeetable107,
      cofeetable108,
      cofeetable109,
      cofeetable110,
      cofeetable111,
      cofeetable112,
      cofeetable113,
      cofeetable114,
      cofeetable115,
      cofeetable116,
      cofeetable117,
      cofeetable118,

    ],
  },

  {
    title: "End Tables",
    subtitle: "Elegant end table designs",
    images: [
      endtable,
      endtable103,
      endtable104,
      endtable105,
      endtable106,
      endtable107,
      endtable108,
      endtable109,
      endtable110,
      endtable111,
      endtable112,
      endtable113,
      endtable114,
      endtable115,
      endtable116,

    ],
  },

  {
    title: "Sculptures",
    subtitle: "Decorative sculptures",
    images: [
      sculpture,
      sculpture1,
      sculpture2,
      sculpture3,
      sculpture4,
      sculpture5,
      sculpture6,
      sculpture7,
      sculpture8,
      sculpture9,
      sculpture10,
      sculpture11,
      sculpture12,
        
    ],
  },

  {
    title: "Desks",
    subtitle: "Modern workspace designs",
    images: [
      desk,
      desk119,
      desk120,
      desk121,
      desk122,
      desk123,
      desk124,
      desk125,
      desk126,
      desk127,
      desk128,
      desk129,
      desk130,
      desk131,
      desk132,
    
    ],
  },

  {
    title: "Bars",
    subtitle: "Stylish bar furniture",
    images: [
      bar,
      bar123,
      bar124,
      bar125,
      bar126,
      bar127,
      bar128,
      bar129,
      bar130,
      bar131,
      bar132,
      bar133,
      bar134,
    
    ],
  },

  {
    title: "Bar Chairs",
    subtitle: "Premium bar seating",
    images: [
      barchair,
      barchair1,
    ],
  },

  {
    title: "TV Units",
    subtitle: "Modern TV unit designs",
    images: [
      tv,
      tvunit115,
      tvunit116,
      tvunit117,
      tvunit118,
      tvunit119,
      tvunit120,
      tvunit121,
      tvunit122,
      tvunit123,
      tvunit124,
      tvunit125,
      tvunit126,
      tvunit127,
      tvunit128,
    
    ],
  },
];


// =====================================================
// COMPONENT
// =====================================================

export default function FurnitureCategories() {

  // Selected category
  const [selectedIndex, setSelectedIndex] = useState(null);

  // Selected image inside category
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);


  // =====================================================
  // OPEN MODAL
  // =====================================================

  const openModal = (index) => {
    setSelectedIndex(index);
    setSelectedImageIndex(0);
  };


  // =====================================================
  // CLOSE MODAL
  // =====================================================

  const closeModal = () => {
    setSelectedIndex(null);
    setSelectedImageIndex(0);
  };


  // =====================================================
  // NEXT IMAGE
  // =====================================================

  const nextImage = () => {

    if (selectedIndex === null) return;

    const images = categories[selectedIndex].images;

    setSelectedImageIndex((prev) =>
      prev === images.length - 1
        ? 0
        : prev + 1
    );
  };


  // =====================================================
  // PREVIOUS IMAGE
  // =====================================================

  const prevImage = () => {

    if (selectedIndex === null) return;

    const images = categories[selectedIndex].images;

    setSelectedImageIndex((prev) =>
      prev === 0
        ? images.length - 1
        : prev - 1
    );
  };


  // =====================================================
  // ESC KEY TO CLOSE MODAL
  // =====================================================

  useEffect(() => {

    const handleKeyDown = (event) => {

      if (event.key === "Escape") {
        closeModal();
      }

      if (
        selectedIndex !== null &&
        event.key === "ArrowRight"
      ) {
        nextImage();
      }

      if (
        selectedIndex !== null &&
        event.key === "ArrowLeft"
      ) {
        prevImage();
      }
    };

    window.addEventListener(
      "keydown",
      handleKeyDown
    );

    return () => {
      window.removeEventListener(
        "keydown",
        handleKeyDown
      );
    };

  }, [selectedIndex]);


  return (

    <section className="furniture-section">

      {/* =====================================================
          HEADING
      ===================================================== */}

      <div className="heading-row">

        <div>

          <span className="sub-title">
            EXPLORE OUR CATEGORIES
          </span>

          <h2>
            Our Furniture Categories
          </h2>

        </div>

      </div>


      {/* =====================================================
          SWIPER
      ===================================================== */}

      <Swiper

        modules={[
          Navigation,
          Autoplay
        ]}

        spaceBetween={25}

        loop={true}

        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}

        navigation

        breakpoints={{

          320: {
            slidesPerView: 1.2,
          },

          768: {
            slidesPerView: 2.5,
          },

          1024: {
            slidesPerView: 4,
          },

          1400: {
            slidesPerView: 5,
          },

        }}

      >

        {categories.map((item, index) => (

          <SwiperSlide key={index}>

            <div
              className="category-card"
              onClick={() => openModal(index)}
            >

              {/* 
                Only first image will be shown
                inside the Swiper card
              */}

              <img
                src={item.images[0]}
                alt={item.title}
              />


              {/* =====================================================
                  OVERLAY
              ===================================================== */}

              <div className="overlay">

                <div>

                  <h3>
                    {item.title}
                  </h3>

                  <p>
                    {item.subtitle}
                  </p>

                </div>


                <div className="arrow-circle">
                  →
                </div>

              </div>

            </div>

          </SwiperSlide>

        ))}

      </Swiper>


      {/* =====================================================
          MODAL
      ===================================================== */}

      {selectedIndex !== null && (

        <div
          className="image-modal"
          onClick={closeModal}
        >

          <div
            className="modal-content"
            onClick={(e) =>
              e.stopPropagation()
            }
          >

            {/* =====================================================
                CLOSE BUTTON
            ===================================================== */}

            <button
              className="close-btn"
              onClick={closeModal}
            >
              ✕
            </button>


            {/* =====================================================
                PREVIOUS BUTTON
            ===================================================== */}

            {categories[selectedIndex].images.length > 1 && (

              <button
                className="modal-arrow left"
                onClick={prevImage}
              >
                ←
              </button>

            )}


            {/* =====================================================
                BIG IMAGE
            ===================================================== */}

            <img
              src={
                categories[selectedIndex]
                  .images[selectedImageIndex]
              }
              alt={
                categories[selectedIndex]
                  .title
              }
              className="modal-image"
            />


            {/* =====================================================
                NEXT BUTTON
            ===================================================== */}

            {categories[selectedIndex].images.length > 1 && (

              <button
                className="modal-arrow right"
                onClick={nextImage}
              >
                →
              </button>

            )}


            {/* =====================================================
                MODAL INFO
            ===================================================== */}

            <div className="modal-info">

              <h2>
                {
                  categories[selectedIndex]
                    .title
                }
              </h2>

              <p>
                {
                  categories[selectedIndex]
                    .subtitle
                }
              </p>


              {/* =====================================================
                  IMAGE COUNTER
              ===================================================== */}

              {categories[selectedIndex].images.length > 1 && (

                <span className="image-counter">

                  {selectedImageIndex + 1}
                  {" / "}
                  {
                    categories[selectedIndex]
                      .images.length
                  }

                </span>

              )}

            </div>


            {/* =====================================================
                THUMBNAILS
            ===================================================== */}

            {categories[selectedIndex].images.length > 1 && (

              <div className="modal-thumbnails">

                {categories[selectedIndex].images.map(
                  (image, index) => (

                    <img
                      key={index}
                      src={image}
                      alt={`${categories[selectedIndex].title} ${index + 1}`}
                      className={
                        selectedImageIndex === index
                          ? "active-thumbnail"
                          : ""
                      }
                      onClick={() =>
                        setSelectedImageIndex(index)
                      }
                    />

                  )
                )}

              </div>

            )}

          </div>

        </div>

      )}

    </section>

  );
}